import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';


import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/admin/core/services/auth.service';
import { AuthfakeauthenticationService } from 'src/app/admin/core/services/authfake.service';
import { User } from 'src/app/shared/models/user';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { SessionService } from 'src/app/shared/service/auth/session/SessionService';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  item: User = new User()
  loading = false;
  showPassword = false;
  configMairie: any = [];

  constructor(
    private authService: AuthService,
    private messageService: MessageService,
    private router: Router,
    private localStorage: LocalStorageService,
    private paramService: ParameterService,
    private sessionService: SessionService
  ) { }






  ngOnInit() {

    this.getLogoNomCommune();
  }




  onSubmit() {
    if (!this.item.canSend()) {
      this.messageService.add({ severity: 'error', summary: 'X-Project', detail: this.item.getErrorMessage() });
      return;
    }

    if (this.item) {

      this.loading = true;
      this.authService.login(this.item).subscribe(
        (response: any) => {
          this.messageService.add({ severity: 'success', summary: 'X-Project', detail: response.message });
          this.sessionService.startAutoLogout();

          this.localStorage.saveInfoUserToService(response)
          this.localStorage.saveExerciceToUserToSuivieEvaluation('')
          this.router.navigate(['/programme']);
        },
        (error: any) => {
          const errorMessage = error?.error?.message
            || error?.error?.error
            || error?.message
            || 'Une erreur est survenue';
          this.messageService.add({ severity: 'error', summary: 'X-Project', detail: errorMessage });
        }
      ).add(() => {
        this.loading = false;
      });
    }
  }//end onSubmit


  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }



  logo: any;
  commune: any;



  getLogoNomCommune() {

    this.paramService.getParamatrageCommune().subscribe(
      (response: any) => {
        // console.log("le logo du webservice", response);
        this.configMairie = response.data
        this.logo = this.configMairie?.logo?.value;
        this.commune = this.configMairie?.commune?.value;
      },
      (error: any) => {
        const errorMessage = error?.error?.message
          || error?.error?.error
          || error?.message
          || 'Une erreur est survenue';
        this.messageService.add({ severity: 'error', summary: 'X-Project', detail: errorMessage });
      }
    )
  }

  onImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    target.src = '../../../assets/new-accueil/logo-vrai.png';
  }
}
